import React from 'react';
import { SOURCE_COLUMNS } from '../../data.js';
import { ColumnChips, ColumnsContext } from '../StepInspector.jsx';

export function MultiCols({ columns, selected = [], onChange, numeric = false, categorical = false }) {
  const ctxCols = React.useContext(ColumnsContext);
  // When numeric=true, only show columns of type 'number' so the user
  // cannot accidentally select a string column for a scaling operation.
  const allCols = (columns || ctxCols || SOURCE_COLUMNS);
  let displayCols = allCols;
  if (numeric) displayCols = allCols.filter(c => c.type === 'number');
  if (categorical) displayCols = allCols.filter(c => c.type === 'string' || c.type === 'boolean');
  return (
    <ColumnChips
      all={displayCols}
      selected={selected}
      onToggle={(name) => onChange(selected.includes(name) ? selected.filter(c => c !== name) : [...selected, name])}
    />
  );
}
